import { useAtomValue } from 'jotai';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { RespondentStatusItem } from '../../../schemas/RespondentApprovalStatus.schema';
import { useRespondentApprovalStatuses } from '../../../services/queries-hooks/RespondentApprovalStatusQueriesHooks';
import { clientConfigFieldsAtom } from '../../../services/state/AppConfigStateJ';
import { MaggieFeatureFlags } from '../../../util/feature-flags';

export function useRespondentApprovalsEnabled(): boolean {
  const isConsolidated =
    (useAtomValue(clientConfigFieldsAtom)?.Using_Consolidated_Data_Collection as boolean) ?? false;
  const { useStarbreakerCollectionV2 } = useFlags<MaggieFeatureFlags>();
  return isConsolidated && useStarbreakerCollectionV2;
}

export interface CompanyOnboardedStatus {
  isOnboarded: boolean;
  companyStatuses: ReadonlyMap<string, RespondentStatusItem> | undefined;
}

// "Onboarded" = the respondent-approval feature is on AND Starbreaker returned at least one
// respondent-status row for this company (presence in the status set is the onboarded signal).
export function useCompanyOnboardedStatus(companyId: number): CompanyOnboardedStatus {
  const enabled = useRespondentApprovalsEnabled();
  const { data: lookup } = useRespondentApprovalStatuses(enabled);
  const companyStatuses = lookup?.get(companyId);
  return { isOnboarded: enabled && (companyStatuses?.size ?? 0) > 0, companyStatuses };
}
